import { render, staticRenderFns } from "./modalActivarInactivar.vue?vue&type=template&id=5b7320de&scoped=true"
import script from "./modalActivarInactivar.vue?vue&type=script&lang=js"
export * from "./modalActivarInactivar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7320de",
  null
  
)

export default component.exports